// extracted by mini-css-extract-plugin
module.exports = {"btnAddStaff":"styles_btnAddStaff__3RM4A"};